import React from 'react';
import Layout from '../components/Layout';
import GlobalAuthorizationLayout from '../components/GlobalAuthorizationLayout';
import Certificates from '../apps/Certificates';
import CheckStaffUserLayout from '../layout/CheckStaffUserLayout';
import CheckViewer from '../layout/CheckViewer';

const CertificatePage: React.FC = () => {
  return (
    <GlobalAuthorizationLayout>
        <CheckStaffUserLayout>
            <CheckViewer>
              <Layout>
                  <Certificates />
              </Layout>
            </CheckViewer>
        </CheckStaffUserLayout>
    </GlobalAuthorizationLayout>
  );
};

export default CertificatePage;
